import type { IconData } from '@stacksjs/iconify-core'

export const shoppingBasket: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.083 0L4.167 4h7.75L9 0h2.5l2.917 4H16v4A8 8 0 1 1 0 8V4h1.583L4.5 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingBasket
